import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/components/DashboardLayout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import { Terms, Privacy } from "@/pages/Legal";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";

import MerchantDashboard from "@/pages/dashboard/MerchantDashboard";
import MerchantKYC from "@/pages/dashboard/MerchantKYC";
import MerchantWallet from "@/pages/dashboard/MerchantWallet";
import MerchantVouchers from "@/pages/dashboard/MerchantVouchers";
import MerchantRedeem from "@/pages/dashboard/MerchantRedeem";
import MerchantHistory from "@/pages/dashboard/MerchantHistory";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminMerchants from "@/pages/admin/AdminMerchants";
import AdminKYC from "@/pages/admin/AdminKYC";
import AdminWallet from "@/pages/admin/AdminWallet";
import AdminVouchers from "@/pages/admin/AdminVouchers";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminSms from "@/pages/admin/AdminSms";
import QA from "@/pages/QA";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* Merchant */}
          <Route path="/dashboard" element={<ProtectedRoute requireRole="merchant"><MerchantDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/kyc" element={<ProtectedRoute requireRole="merchant"><MerchantKYC /></ProtectedRoute>} />
          <Route path="/dashboard/wallet" element={<ProtectedRoute requireRole="merchant"><MerchantWallet /></ProtectedRoute>} />
          <Route path="/dashboard/vouchers" element={<ProtectedRoute requireRole="merchant"><MerchantVouchers /></ProtectedRoute>} />
          <Route path="/dashboard/redeem" element={<ProtectedRoute requireRole="merchant"><MerchantRedeem /></ProtectedRoute>} />
          <Route path="/dashboard/history" element={<ProtectedRoute requireRole="merchant"><MerchantHistory /></ProtectedRoute>} />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute requireRole="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/merchants" element={<ProtectedRoute requireRole="admin"><AdminMerchants /></ProtectedRoute>} />
          <Route path="/admin/kyc" element={<ProtectedRoute requireRole="admin"><AdminKYC /></ProtectedRoute>} />
          <Route path="/admin/wallet" element={<ProtectedRoute requireRole="admin"><AdminWallet /></ProtectedRoute>} />
          <Route path="/admin/vouchers" element={<ProtectedRoute requireRole="admin"><AdminVouchers /></ProtectedRoute>} />
          <Route path="/admin/audit" element={<ProtectedRoute requireRole="admin"><AdminAudit /></ProtectedRoute>} />
          <Route path="/admin/sms" element={<ProtectedRoute requireRole="admin"><AdminSms /></ProtectedRoute>} />
          <Route path="/qa" element={<ProtectedRoute requireRole="admin"><QA /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
